import { PropertyConditionName } from '@invenco/common-domain/enums';
import { OrderCurrency, FulfilmentServiceType } from '@invenco/sales-interface/interfaces';

import { skuNameValueInputDetails } from './commonValueInputs';
import { InputValueDetails } from './types';

export const propertyConditionOverrides: Partial<Record<PropertyConditionName, InputValueDetails>> =
  {
    skuName: skuNameValueInputDetails,
    tagName: {
      type: 'search',
      queryKey: 'tags',
      valueKey: 'name',
      query: ({ salesGateway }, input, options) => salesGateway.getTags(input, options),
    },
    channelName: {
      type: 'search',
      queryKey: 'channels',
      valueKey: 'name',
      query: ({ salesGateway }, input, options) => salesGateway.getChannels(input, options),
    },
    ORDER_CHANNEL_NAME: {
      type: 'select',
      queryKey: 'channels',
      valueKey: 'name',
      multi: true,
      query: ({ salesGateway }, input, options) => salesGateway.getChannels(input, options),
    },
    ORDER_SHIPPING_PROFILE_ID: {
      type: 'select',
      queryKey: 'shippingProfiles',
      labelKey: 'name',
      valueKey: 'id',
      query: ({ salesGateway }, input, options) => salesGateway.getShippingProfiles(input, options),
    },
    currency: {
      type: 'select',
      options: Object.values(OrderCurrency),
    },
    totalItems: { type: 'integer' },
    totalPrice: { type: 'float' },
    totalVolume: { type: 'float' },
    customerOrderNumber: { type: 'integer' },
    WAREHOUSE_SHIPMENT_TOTAL_ITEMS: { type: 'integer' },
    WAREHOUSE_SHIPMENT_TOTAL_VOLUME: { type: 'float' },
    WAREHOUSE_SHIPMENT_TOTAL_WEIGHT: { type: 'float' },
    WAREHOUSE_SHIPMENT_FULFILLMENT_SERVICE_TYPE: {
      type: 'select',
      options: Object.values(FulfilmentServiceType),
    },
  };
